module.exports = __webpack_public_path__ + "static/rock3-031c7253c5544f08356df3db83a43e9a.svg";